import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import { decorateIntlMessages } from '../common/rosetta_formatted_message';
import {map} from 'lodash';
import toSentence from '../../utils/toSentence';

const messages = decorateIntlMessages(__filename, defineMessages({
  bylineSeparator: {
    id: 'byline_separator',
    description: 'Separator for bylines',
    defaultMessage: '; '
  },
  bylineTupleSeparator: {
    id: 'byline_tuple_separator',
    description: 'Separator for two bylines',
    defaultMessage: '; '
  },
  bylineLastSeparator: {
    id: 'byline_last_separator',
    description: 'Separator for last byline',
    defaultMessage: '; '
  }
}));

const Byline = ({ byline, name }) => (
  <RosettaFormattedMessage parentFilename={__filename}
    id="byline"
    key={byline + name}
    description="Non-writer byline in the footer"
    defaultMessage="{byline} by {name}"
    values={{
      byline,
      name: <span dangerouslySetInnerHTML={{ __html: name }} />
    }}
  />
);

Byline.propTypes = {
  name: PropTypes.string.isRequired,
  byline: PropTypes.string.isRequired
};

const getMainBylineComponents = bylines => map(bylines, ({ byline, name }) => (
  <Byline key={byline + name}
    byline={byline}
    name={name}
  />
));

const getOpenerImageBylineComponent = byline => byline &&
  <span key={byline} dangerouslySetInnerHTML={{ __html: byline }} />;

const getAllBylineComponents = (bylines, openerImageCredit) => {
  const mainBylines = getMainBylineComponents(bylines);
  const openerImageByline = getOpenerImageBylineComponent(openerImageCredit);
  return openerImageByline
    ? [...mainBylines, openerImageByline]
    : mainBylines;
};

const OtherContributors =
  ({ bylines, openerImageCredit, intl: { formatMessage } }) => (
    <div className="byline other-contributors">
      {
        toSentence(
          getAllBylineComponents(bylines, openerImageCredit),
          {
            separator: formatMessage(messages.bylineSeparator),
            tupleSeparator: formatMessage(messages.bylineTupleSeparator),
            lastSeparator: formatMessage(messages.bylineLastSeparator)
          }
        )
      }
    </div>
  );

OtherContributors.propTypes = {
  bylines: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      byline: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  openerImageCredit: PropTypes.string,
  intl: PropTypes.object.isRequired
};

export default injectIntl(OtherContributors);
